<template>
  <div class="container is-fluid">
    
    <div class="level">
        <div class="level-left">
            <h1 class="title ">View Application for {{application.forename}} {{application.surname}} <span class="tag is-info" v-if="application.coaching==1">Coaching</span></h1>
        </div>
        <div class="level-right" v-if="application.contact_id > 0">
            <div class="buttons  is-right">
            <router-link :to="'/contacts/' + application.contact_id + '/applications'"><button class="button is-info">Back to Contact</button></router-link>
        
            </div>
        </div>
    </div>
    
   
    <div class="box " v-if="!notfound">
      <h1 class="title ">Personal Details</h1>	
     <form @submit.prevent="updatePersonalDetails">
      <div class="field">
                    <label class="label">Applicant Name *</label>
                    <div class="columns">
                        <div class="column is-2">
                            <div class="control">
                                <input class="input" type="text" placeholder="Title" v-model="application.title" maxlength="20">
                            </div>
                        </div>
                        <div class="column is-5">
                            <div class="control">
                                <input class="input" type="text" required placeholder="First Name" v-model="application.forename" maxlength="100">
                            </div>
                        </div>
                        <div class="column is-5">
                            <div class="control">
                                <input class="input" type="text" required placeholder="Last Name" v-model="application.surname" maxlength="100">
                            </div>
                        </div>
                    </div>
                </div>
                 <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Date of Birth</label>
                            <div class="control">
                                <datepicker v-model="application.dob" input-class="input" name="dob" monday-first  format="dd/MM/yyyy"  placeholder="dd/mm/yyyy"></datepicker>
                                
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Email</label>
                            <div class="control">
                                <input class="input" type="email" required placeholder="" v-model="application.email" maxlength="200">
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="field" >
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Parent/Guardian Name</label>
                            <div class="control">
                                 <input class="input" type="text"  placeholder="" v-model="application.parent_name" maxlength="200">
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Relationship to Applicant</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="application.parent_relationship" maxlength="200">
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="field" >
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Parent/Guardian Telephone</label>
                            <div class="control">
                                 <input class="input" type="text"  placeholder="" v-model="application.parent_telephone" maxlength="200">
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Parent/Guardian Email</label>
                            <div class="control">
                                <input class="input" type="email"  placeholder="" v-model="application.parent_email" maxlength="200">
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Telephone (Home)</label>
                            <div class="control">
                                <input class="input" type="text" placeholder="" v-model="application.telephone" maxlength="100">
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Telephone (Mobile)</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="application.mobile" maxlength="100">
                            </div>
                        </div>
                        
                    </div>
                </div>

                <div class="field" v-if="application.council_area != ''">
                   <label class="label">Borough, District or City Council Area in which you live</label>
                    <div class="control">
                        <input class="input" type="text"  placeholder="Borough/District/City Council Area – this is NOT your education and library board." v-model="application.council_area" maxlength="100">
                        
                    </div>
                    
                </div>

                 <div class="field" >
                   <label class="label">Council Area</label>
                    <div class="select is-fullwidth">
                            <select v-model="application.council_area_id" >
                                <option value="">Select Council Area ...</option>
                                <option v-for="row in council_areas" :key="row.id" :value="row.id">{{ row.name }}</option>
                            </select>
                        </div>
                    
                </div>
                
                <div class="field">
                   <label class="label">Address</label>
                    <div class="control">
                        <input class="input" type="text"  placeholder="" v-model="application.address" maxlength="200">
                        
                    </div>
                    
                </div>
                 <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">City</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="application.city" maxlength="100">
                                
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">State/Province/Region</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="application.state" maxlength="100">
                            </div>
                        </div>
                        
                    </div>
                </div>
                 <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Postcode</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="application.postcode" maxlength="50">
                                
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Country</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="application.country" maxlength="100">
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Name Of School</label>
                            <div class="control">
                                <input class="input" type="text" placeholder="" v-model="application.school_name" maxlength="100">
                            </div>
                        </div>
                        <div class="column ">
                            <label class="label">Instagram / Twitter Handles</label>
                            <div class="control">
                                <input class="input" type="text"  placeholder="" v-model="application.social_handle" maxlength="500">
                            </div>
                        </div>
                        
                    </div>
                </div>
                 <div class="field">
                    <div class="columns">
                        <div class="column ">
                             <label class="label">Employment</label>
                            <div class="select is-fullwidth">
                                <select v-model="application.employment" class="input">
                                    <option value="">Please select ...</option>
                                    <option value="Full Time">Full Time</option>
                                    <option value="Part Time">Part Time</option>
                                    <option value="N/A">N/A</option>
                                </select>
                            </div>
                        </div>
                        <div class="column ">
                             <label class="label">Education</label>
                            <div class="select is-fullwidth">
                                <select v-model="application.education" class="input">
                                    <option value="">Please select ...</option>
                                    <option value="Full Time">Full Time</option>
                                    <option value="Part Time">Part Time</option>
                                    <option value="N/A">N/A</option>
                                </select>
                            </div>
                        </div>
                        
                    </div>
                </div>

      <div class="buttons " >
        
          <button class="button is-success" v-show="!isSaving">
            {{update_button_text}}
          </button>

          <button type="button" class="button is-warning" v-show="isSaving">
            Saving ...
          </button>
          
        
       
      </div>
      </form>

    </div>

    <div class="box" v-if="!notfound">
         <h1 class="title ">Funding Requirements <span v-if="application.coaching==1"><strong> - Details below relate to a coaching course</strong></span></h1>
         <form @submit.prevent="updateFunding">  
          <div class="field">
                <label class="label">Targeted event for which funding is requested</label>
                <div class="control">
                    <input class="input" type="text"  placeholder="ONE main event only to be listed" v-model="application.target_event" maxlength="500">
                </div>
            </div>

            <div class="field">
                <div class="columns">
                    <div class="column ">
                          <label class="label">Date of Targeted Event</label>
                        <div class="control">
                            <input class="input" type="text" placeholder="" v-model="application.target_event_date" maxlength="100">
                        </div>
                    </div>
                    <div class="column ">
                        <label class="label">Venue of Targeted Event</label>
                        <div class="control">
                            <input class="input" type="text"  placeholder="" v-model="application.target_event_venue" maxlength="100">
                        </div>
                    </div>
                    <div class="column ">
                        <label class="label">Estimated Cost of Targeted Event</label>
                        <div class="control">
                            <input class="input" type="text"  placeholder="" v-model="application.target_event_cost" maxlength="100">
                        </div>
                    </div>
                    
                </div>
            </div>

            <div class="field">
                <label class="label">Training &amp; Competitive Programme in preparation for Targeted Event</label>
                <p class=""><em>Detailed programme of training and competitions that will assist the Trust to make the appropriate level of award.</em></p>
                
                
            
                <div class="columns mb-0" >
                    
                    <div class="column is-8 ">
                        <strong>Details</strong>
                    </div>
                    <div class="column is-3">
                        <strong>Cost (&pound;)</strong>
                    </div>
                    <div class="column is-1">
                        
                    </div>
                </div>
                <div class="columns mb-0" v-for="(row, index) in application.training" :key="index">
                    
                    <div class="column is-8">
                        <div class="control">
                            <input class="input" type="text" placeholder="Details" v-model="row.details" maxlength="500">
                        </div>
                    </div>
                    <div class="column is-3">
                        <div class="control">
                            <input class="input" type="text"  placeholder="Cost (£)" v-model="row.cost" maxlength="100" >
                        </div>
                    </div>
                    <div class="column is-1">
                        <a class="delete is-large" @click="application.training.splice(index, 1);"></a>
                    </div>
                </div>
                <button class="button is-info is-small" type="button" @click="addTrainingItem()"> 
                    <span class="icon">
                    <i class="fa fa-plus"></i>
                    </span>
                    <span>Add New Item</span>
                </button>
            </div>

            <div class="field">
                <label class="label"> Details of other financial support revieved in past 12 months (Must be fully competed)</label>
                <div class="columns mb-0" >
                    
                    <div class="column is-4 ">
                        <strong>Finance Body</strong>
                    </div>
                    <div class="column is-2">
                        <strong>Amount (&pound;)</strong>
                    </div>
                    <div class="column is-2">
                        <strong>Date Received</strong>
                    </div>
                    <div class="column is-3">
                        <strong>Other Comments</strong>
                    </div>
                    <div class="column is-1">
                        
                    </div>
                </div>
                <div class="columns mb-0" v-for="(row, index) in application.support" :key="index">
                    
                    <div class="column is-4">
                        <div class="select is-fullwidth">
                            <select v-model="row.finance_body">
                                <option value="">Select Finance Body ...</option>
                                <option v-for="(option, index) in finance_bodies" v-bind:value="option" :key="index">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="column is-2">
                        <div class="control">
                            <input class="input" type="text"  placeholder="Amount (£)" v-model="row.amount" maxlength="100" >
                        </div>
                    </div>
                      <div class="column is-2">
                        <div class="control">
                            <input class="input" type="text"  placeholder="Date Received" v-model="row.date" maxlength="100" >
                        </div>
                    </div>
                      <div class="column is-3">
                        <div class="control">
                            <input class="input" type="text"  placeholder="Comments" v-model="row.comments" maxlength="500" >
                        </div>
                    </div>
                    <div class="column is-1">
                        <a class="delete is-large" @click="application.support.splice(index, 1);"></a>
                    </div>
                </div>
                <button class="button is-info is-small" type="button" @click="addSupportItem()"> 
                    <span class="icon">
                    <i class="fa fa-plus"></i>
                    </span>
                    <span>Add New Item</span>
                </button>
            </div>

            <div class="field">
                <label class="label">Governing Body Report and Recommendations (to be completed by Governing Body only)</label>
                <div class="columns mb-0" >
                    
                    <div class="column is-5 ">
                        <strong>Ranking Area</strong>
                    </div>
                    <div class="column is-6">
                        <strong>Rank</strong>
                    </div>
                    
                    <div class="column is-1">
                        
                    </div>
                </div>
                <div class="columns mb-0" v-for="(row, index) in application.ranking" :key="index">
                    
                    <div class="column is-5">
                        <div class="select is-fullwidth">
                            <select v-model="row.area">
                                <option value="">Select Ranking Area ...</option>
                                <option v-for="(option, index) in ranking_areas" v-bind:value="option" :key="index">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="column is-6">
                        <div class="control">
                            <input class="input" type="text"  placeholder="Rank" v-model="row.rank" maxlength="500" >
                        </div>
                    </div>
                    
                    <div class="column is-1">
                        <a class="delete is-large" @click="application.ranking.splice(index, 1);"></a>
                    </div>
                </div>
                <button class="button is-info is-small" type="button" @click="addRankingItem()"> 
                    <span class="icon">
                    <i class="fa fa-plus"></i>
                    </span>
                    <span>Add New Item</span>
                </button>
            </div>

            <div class="field" v-if="application.coaching==1">
                <label class="label">Supporting Statement</label>
                <textarea class="textarea" placeholder="" v-model="application.supporting_statement"></textarea>
            </div>

            <div class="field" v-if="application.coaching==1">
                <label class="label">Previous Funding</label>
                <textarea class="textarea" placeholder="" v-model="application.previous_funding"></textarea>
            </div>
            
            <div class="field">
                <label class="label">Major Achievements (in the past 2 years, in chronological order)</label>
                <textarea class="textarea" placeholder="Detail MAJOR achievements only eg; 1st Irish Championships 100m, 2nd place in UK Championships, 5th place in Europe" v-model="application.achievements"></textarea>
            </div>

            <div class="field">
                <label class="label">Potential</label>
                <textarea class="textarea" placeholder="Please outline the long term potential of this applicant" v-model="application.potential"></textarea>
            </div>

            <div class="field">
                <label class="label">Other Relevant Comments</label>
                <textarea class="textarea" placeholder="Please confine comments to sporting history.  It would also be helpful to know the competitive numbers of those involved in this discipline." v-model="application.other_comments"></textarea>
            </div>

            <div class="field">
                <label class="label">Assessment of financial need</label>
                <div class="columns mb-0" >
                    
                    <div class="column is-3 ">
                        <strong>Priority</strong>
                    </div>
                    <div class="column is-8">
                        <strong>Comments</strong>
                    </div>
                    
                    <div class="column is-1">
                        
                    </div>
                </div>
                <div class="columns mb-0" v-for="(row, index) in application.needs" :key="index">
                    
                    <div class="column is-3">
                        <div class="select is-fullwidth">
                            <select v-model="row.priority">
                                <option value="">Select Priority ...</option>
                                <option v-for="(option, index) in priority_options" v-bind:value="option" :key="index">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="column is-8">
                        <div class="control">
                            <input class="input" type="text"  placeholder="Comments" v-model="row.comments" maxlength="500" >
                        </div>
                    </div>
                    
                    <div class="column is-1">
                        <a class="delete is-large" @click="application.needs.splice(index, 1);"></a>
                    </div>
                </div>
                <button class="button is-info is-small" type="button" @click="addNeedItem()"> 
                    <span class="icon">
                    <i class="fa fa-plus"></i>
                    </span>
                    <span>Add New Item</span>
                </button>
            </div>

          <div class="buttons">
             <button class="button is-success" v-show="!isSaving">
            {{update_button_text}}
          </button>

          <button type="button" class="button is-warning" v-show="isSaving">
            Saving ...
          </button>
          
              
          </div>
          </form>
    </div>

    <div class="box " v-if="!$auth.loading && application.awarded == 0 && ($auth.user.roles.includes('officer') || $auth.user.roles.includes('admin'))">	
     
      <div class="row mb-4">
        <p>You can choose to Endorse this application or not endorse it. If you choose to Endorse, it will move through to the next stage of the application process.</p>
        <p><em>Please make sure that if you have changed details above, you must press the green Update Details button to save the changes before performing this next action.</em></p>
      </div>
     

      <div class="field has-addons">
        <p class="control">
          <button class="button" @click="endorseApplication()" v-bind:class="{ 'is-success' : application.endorsed == 1}">
             <span>Endorse</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="notEndorseApplication()" v-bind:class="{ 'is-danger' : application.endorsed == 2}">
            <span>Not Endorse</span>
          </button>
        </p>
        
      </div>

      <div id="endorse_errors_div" class="notification is-danger" v-show="endorse_error != ''">
          {{endorse_error}}
      </div>


    </div>

    <div class="box " v-if="!$auth.loading && application.endorsed === 1 && ( $auth.user.roles.includes('admin'))">	
     
      <div class="row mb-4">
        <p>You can choose to set this application as Awarded once it has been agreed that funding will be given. You will then be able to add details of the funding.</p>
      </div>
     

      <div class="field has-addons">
        <p class="control">
          <button class="button" @click="awardApplication()" v-bind:class="{ 'is-success' : application.awarded == 1}">
             <span>Awarded</span>
          </button>
        </p>
        <p class="control">
          <button class="button" @click="notAwardApplication()" v-bind:class="{ 'is-danger' : application.awarded == 2}">
            <span>Not Awarded</span>
          </button>
        </p>
        
      </div>

      <div id="award_errors_div" class="notification is-danger" v-show="award_error != ''">
          {{award_error}}
      </div>


    </div>

     <div class="box " v-if="!notfound && !$auth.loading &&  ( $auth.user.roles.includes('admin'))">
      <h5 class="title is-5 mb-2">Application Uploads</h5>
        <table class="table is-fullwidth">
          <thead>
              <tr>
                  <th>Date/Time</th>
                  <th>Name</th>
                  <th>User</th>
                  <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in application.uploads" v-bind:key="row.id">
                    <td>{{ row.created_at }}</td>
                     <td><a :href="row.s3_link" target="_blank">{{ row.name }}</a></td>
                      <td>{{ row.forename }} {{ row.surname }}</td>
                      <td></td>
                  </tr>
              </tbody>
          </table>
            <h3 class="title is-5 mb-2">Upload New Document</h3>
          <input type="file" name="fileupload" ref="fileupload" @change="uploadFile()"/><br />
      </div>

      <div class="box " v-if="!notfound && !$auth.loading &&  ( $auth.user.roles.includes('admin')) && application.awarded===1">
      <h5 class="title is-5 mb-2">Funding</h5>
        <table class="table is-fullwidth">
          <thead>
              <tr>
                  <th>Date/Time</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Comments</th>
                  <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in application.fundings" v-bind:key="row.id">
                    <td>{{ row.date }}</td>
                     <td>{{ row.name }}</td>
                      <td>{{ row.amount}}</td>
                       <td>{{ row.comments}}</td>
                      <td></td>
                  </tr>
              </tbody>
          </table>
           <router-link :to="'/applications/' + application.id + '/addapplicationfunding'"><button class="button is-info is-small">Add Funding</button></router-link>
      </div>

    <div class="box " v-if="!notfound">
      <h5 class="title is-5 mb-2">History of Application</h5>
        <table class="table is-fullwidth">
          <thead>
              <tr>
                  <th>Date/Time</th>
                  <th>Event</th>
                  <th>User</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="log in application.logs" v-bind:key="log.id">
                    <td>{{ log.date }}</td>
                     <td>{{ log.event }}</td>
                      <td>{{ log.forename }} {{ log.surname }}</td>
                  </tr>
              </tbody>
          </table>
      </div>

   

      
            

    <div class="notification is-warning" v-if="notfound">
        The details of this application cannot be displayed.
    </div>


  </div>
</template>

<script>


import ApplicationService from '@/services/ApplicationService.js';
import Datepicker from 'vuejs-datepicker';
import ApplicationMixin from "@/mixins/ApplicationMixin.js";

export default {
  components: {
   	Datepicker
  },
   mixins: [ApplicationMixin],
  data() {
    return {
      application: {council_area_id:''},
      endorse_error: '',
      award_error: '',
      isSaving:null,
      saveSuccessful:null,
      saveError:null,
      notfound:null,
      update_button_text: 'Update Details',
      ranking_areas:['Northern Ireland', 'GB/UK', 'Ireland', 'Europe', 'World'],
        priority_options:['Low', 'Medium', 'High'],
        finance_bodies: ['Sport NI: Athlete Support Programme', 'Sport Ireland: International Carding Scheme', 'Borough/District/City Council/ Sports Advisory Council', 
        'University Bursary', 'Previous Mary Peters Trust Award', 'Other – please state in comments >'],
        accessToken: '',
        council_areas:[]
  
    }
  },
  

  // Fetches posts when the component is created.
  created() {
    
    
    this.getAccessToken()
    .then(() => { 
        this.getApplicationData();
        this.getCouncilAreas();
    });
   
  },
  methods: {
    async updatePersonalDetails() {
       this.isSaving = 1
       
      
        var data = { type: 'personal', application: this.application}; 

        ApplicationService.updateApplication(this.accessToken, this.$route.params.id, data)
        .then((response) => {
            this.form_success = 1
            this.form_error = 0
            this.isSaving = 0
            this.update_button_text = "Saved successfully"

            setTimeout(()=>{
            this.resetUpdateButtonText()
            },2000);

            this.$set(this, "application", response);
           

             
            console.log("Good:" + response.data);
            }).catch((error) => {
                this.form_error = 1
                if(error.response.status === 422)
                {
                    console.log("Error:" + JSON.stringify(error.response.data));
                }
            
        });
    },
    async updateFunding() {
       this.isSaving = 1
       
         var data = { type: 'personal', application: this.application}; 

        ApplicationService.updateApplication(this.accessToken, this.$route.params.id, data)
        .then((response) => {
            this.form_success = 1
            this.form_error = 0
             this.isSaving = 0
            this.update_button_text = "Saved successfully"

             setTimeout(()=>{
            this.resetUpdateButtonText()
            },2000);

            this.$set(this, "application", response);

            console.log("Good:" + response.data);
            }).catch((error) => {
                this.form_error = 1
                if(error.response.status === 422)
                {
                    console.log("Error:" + JSON.stringify(error.response.data));
                }
            
        });
    },
    
    
    async endorseApplication() {
      this.endorse_error = ""
     
      // Use the eventService to call the getEventSingle() method
      ApplicationService.endorseApplication(this.accessToken, this.$route.params.id, 1)
      .then(
        (application => {
          this.$set(this, "application", application);
         
        }).bind(this)
        
      )
      .catch((error) => {
        this.endorse_error = error.response.data.message
        
      });
    }
    ,
    async notEndorseApplication() {
      this.endorse_error = ""
      
      // Use the eventService to call the getEventSingle() method
      ApplicationService.endorseApplication(this.accessToken, this.$route.params.id, 2)
      .then(
        (application => {
          this.$set(this, "application", application);
         
        }).bind(this)
      )
      .catch((error) => {
        this.endorse_error = error.response.data.message
        
      });
    },
    async awardApplication() {
      this.award_error = ""
     
      // Use the eventService to call the getEventSingle() method
      ApplicationService.awardApplication(this.accessToken, this.$route.params.id, 1)
      .then(
        (application => {
          this.$set(this, "application", application);
         
        }).bind(this)
        
      )
      .catch((error) => {
        this.award_error = error.response.data.message
        
      });
    }
    ,
    async notAwardApplication() {
      this.award_error = ""
      
      // Use the eventService to call the getEventSingle() method
      ApplicationService.awardApplication(this.accessToken, this.$route.params.id, 2)
      .then(
        (application => {
          this.$set(this, "application", application);
         
        }).bind(this)
      )
      .catch((error) => {
        this.award_error = error.response.data.message
        
      });
    },
    addTrainingItem() {
        this.application.training.push({'details': '', 'cost' : ''})
        
    },
    addSupportItem() {
        this.application.support.push({'finance_body': '', 'amount' : '', 'date' : '', 'comments' : ''})
        
    },
    addRankingItem() {
        this.application.ranking.push({'area': '', 'rank' : ''})
       
    },
    addNeedItem() {
        this.application.needs.push({'priority': '', 'comments' : ''})
        
    },
    resetUpdateButtonText() {
        this.update_button_text = "Update Details"
    },
    async uploadFile()
      {
        this.file = event.target.files[0];

        let formData = new FormData();
        formData.append('upload', this.file);
         formData.append('application_id', this.application.id);
        
        ApplicationService.uploadFile(this.accessToken, formData)
        .then(() => {
            this.getApplicationData();
            this.$refs.fileupload.value=null;
        })
        .catch(error => {
            alert("An error occurred uploading that file - " + error)
            this.$refs.fileupload.value=null;
        });
      }

  }
}

// used to be on button  v-if="this.user["https://app.test202.co.uk/roles"].includes('sales')"
</script>

<style>
	
</style>
